import { isDearisObjectSearchDevice } from "@/shared/objectSearchDevice";
import type { Building, DeviceType, Property } from "@/types";

import ControllerBuildingCard from "./ControllerBuildingCard";
import LiteBuildingCard from "./LiteBuildingCard";
import PatmoBuildingCard from "./PatmoBuildingCard";

interface IBuildingCardProps {
  type: DeviceType;
  titleLighted?: boolean;
  buildingOrProperty: Building | Property;
  [key: string]: any;
}

export function BuildingCard({
  type,
  titleLighted,
  buildingOrProperty,
  ...rest
}: Readonly<IBuildingCardProps>) {
  if (isDearisObjectSearchDevice(type)) {
    return (
      <ControllerBuildingCard
        titleLighted={titleLighted}
        className={rest.className}
        property={buildingOrProperty as Property}
        onClick={rest.onClick}
      />
    );
  }
  switch (type) {
    case "PATMO":
      return (
        <PatmoBuildingCard
          titleLighted={titleLighted}
          className={rest.className}
          property={buildingOrProperty as Property}
          onClick={rest.onClick}
        />
      );
    case "PabbitLite":
      return (
        <LiteBuildingCard
          titleLighted={titleLighted}
          className={rest.className}
          building={buildingOrProperty as Building}
          onClick={rest.onClick}
        />
      );
  }
}
